import "./MyGamesTable.style.css";

import { GameCardState } from "../../../utils/states/ConstructorPageStates/GameCardState";
import { GameCard } from "../../../components/special/GameCard/GameCard";
import { Link, useNavigate } from "react-router-dom";
import { AppRouter } from "../../../utils/enums/AppRouter";
import { ApiFactory } from "../../../api-client/api-factory";
import { GamesApi } from "../../../api-client";
import { GameCardMapper } from "../../../utils/mappers/GameCardMapper";
import { DEFAULT_GAME_IMAGE } from "../../../utils/constants/constants";

import loadingImage from "../../../resources/images/loading.png";
import addGameImage from "./../../../resources/images/add_game.png";

interface MyGamesTableProps {
  gameCards: GameCardState[];
  isMyGamesReceived: boolean;
  username: string;
}

export const MyGamesTable = ({
  gameCards,
  isMyGamesReceived,
  username,
}: MyGamesTableProps) => {
  const navigate = useNavigate();

  const createGame = () => {
    const newGame = {
      apiId: null,
      image: DEFAULT_GAME_IMAGE,
      name: "Новая игра",
      author: username,
      playersTodayCount: 0,
      playersAllCount: 0,
      favoriteCount: 0,
      tags: [],
    };

    ApiFactory.get(GamesApi)
      .gamesPost(GameCardMapper.toCreateGameRequest(newGame))
      .then((data) => {
        console.log("Создание прошло успешно");
        if (data.id) {
          navigate(AppRouter.Constructor.replace(":gameId", data.id));
        }
      })
      .catch(() => console.error("ERR: Не получилось создать игру"));
  };

  return (
    <div className="my-games-table__wrapper">
      <div className="my-games-table">
        {isMyGamesReceived && (
          <button
            onClick={createGame}
            className="my-games-table__add-game-card header_3"
          >
            <img src={addGameImage} alt="Создать новую игру" />
            Новая игра
          </button>
        )}
        {isMyGamesReceived ? (
          gameCards.map((gameCard, index) => (
            <Link
              to={
                gameCard.apiId
                  ? AppRouter.Constructor.replace(":gameId", gameCard.apiId)
                  : AppRouter.MyGames
              }
              key={index}
            >
              <GameCard gameCard={gameCard} />
            </Link>
          ))
        ) : (
          <div className="loading_block header_2">
            <img className="loading" src={loadingImage} alt="loading..." />
            Загружаем...
          </div>
        )}
      </div>
    </div>
  );
};
